/**
 *  Should contain the group of fields that will be rendered
 * IMPORTANT: This is the defnition only for Purchase order.
 * This relies on fieldName to have an exact match, any change
 * on the names of the fields will cause this not work correctly
 *
 */
export const FORM_SECTION_DEFINITIONS = {
    orderManagement: [
        { fieldName: 'assignedTo', columns: 6, label: 'Assign to' },
        { fieldName: 'statusId', columns: 6, label: 'Status' }
    ],
    orderInformation: [
        { fieldName: 'PO Number', columns: 6, label: 'PO Number' },
        { fieldName: 'Date Ordered', columns: 6, label: 'Order Date' },
        { fieldName: 'Requested Delivery Date', columns: 6, label: 'Delivery Date' },
        { fieldName: 'Amount', columns: 6, label: 'Amount' }
    ],
    contactInformation: [
        { fieldName: 'Contact Name', columns: 6, label: 'Contact Name' },
        { fieldName: 'Email 1', columns: 6, label: 'Email address' },
        { fieldName: 'Phone 1', columns: 6, label: 'Phone Number' },
        { fieldName: 'Position', columns: 6, label: 'Position' }
    ],
    dealerInformation: [
        { fieldName: 'Dealer Name', columns: 12, label: 'Name' },
        { fieldName: 'Dealer Address', columns: 6, label: 'Address 1' },
        { fieldName: 'Dealer Address 2', columns: 6, label: 'Address 2' },
        { fieldName: 'Dealer Country', columns: 6, label: 'Country' },
        { fieldName: 'Dealer City', columns: 6, label: 'City' },
        { fieldName: 'Dealer State', columns: 6, label: 'State' },
        { fieldName: 'Dealer Zip', columns: 6, label: 'Zip code' }
    ],
    shipTo: [
        { fieldName: 'Ship to Contact Name', columns: 12, label: 'Name' },
        { fieldName: 'Ship To Address', columns: 6, label: 'Address 1' },
        { fieldName: 'Ship to Address 2', columns: 6, label: 'Address 2' },
        { fieldName: 'Ship to Country', columns: 6, label: 'Country' },
        { fieldName: 'Ship to City', columns: 6, label: 'City' },
        { fieldName: 'Ship to State', columns: 6, label: 'State' },
        { fieldName: 'Ship To Zip Code', columns: 6, label: 'Zip code' }
    ],
    billTo: [
        { fieldName: 'Bill to Name', columns: 12, label: 'Name' },
        { fieldName: 'Bill To Address', columns: 6, label: 'Address 1' },
        { fieldName: 'Bill To Address 2', columns: 6, label: 'Address 2' },
        { fieldName: 'Bill To Country', columns: 6, label: 'Country' },
        { fieldName: 'Bill To City', columns: 6, label: 'City' },
        { fieldName: 'Bill To State', columns: 6, label: 'State' },
        { fieldName: 'Bill To Zip Code', columns: 6, label: 'Zip code' }
    ],
    endCustomer: [
        { fieldName: 'End Customer Name', columns: 12, label: 'Name' },
        { fieldName: 'End Customer Address 1', columns: 6, label: 'Address 1' },
        { fieldName: 'End Customer Address 2', columns: 6, label: 'Address 2' },
        { fieldName: 'End Customer Country', columns: 6, label: 'Country' },
        { fieldName: 'End Customer City', columns: 6, label: 'City' },
        { fieldName: 'End Customer State', columns: 6, label: 'State' },
        { fieldName: 'End Customer Zip', columns: 6, label: 'Zip code' }
    ]
} as const;
